import SampleBeerImg1 from './1';
import SampleBeerImg2 from './2';
import SampleBeerImg3 from './3';
import SampleBeerImg4 from './4';
import SampleBeerImg5 from './5';

export const SampleImages = [
  SampleBeerImg1,
  SampleBeerImg2,
  SampleBeerImg3,
  SampleBeerImg4,
  SampleBeerImg5,
];
